import { MoneyRequestCardProps } from "declarations/card";
import { useDispatch } from "react-redux";
import { setMoneyRequest } from "reducers/requestReducer";

function MoneyRequestCard({ request }: MoneyRequestCardProps) {
  const dispatch = useDispatch();

  const status = request.status;

  const handleOnClick = () => {
    dispatch(setMoneyRequest(request));
  };

  return (
    <div className={Classname.container} onClick={handleOnClick}>
      <div className="flex flex-col flex-1 gap-2">
        <span>
          User: <span className="font-medium">{request.user?.name || "Unknown user"}</span>
        </span>
        <span>
          Phone: <span className="font-medium">{request.user?.phoneNumber || "No phone"}</span>
        </span>
        <span
          className={`h-[37px] mt-2 rounded-md w-full text-white text-sm lg:text-base flex items-center justify-center ${
            status === "Approved"
              ? "bg-[#52C93F]"
              : status === "Denied"
              ? "bg-[#E73E3E]"
              : "bg-[#F8C40D]"
          } `}
        >
          {status === "Approved"
            ? "Sent"
            : status === "Denied"
            ? "Cancelled"
            : "Requested"}
        </span>
      </div>
      <div className="">
        <img
          src={request.screenshot}
          alt="Payment proof"
          className="ml-2 h-16 w-16 rounded-lg border border-slate-200 object-cover"
        />
      </div>
    </div>
  );
}

export default MoneyRequestCard;

const Classname = {
  container:
    "my-1 flex w-full cursor-pointer rounded-xl border border-transparent bg-white p-4 transition-colors hover:border-slate-200 hover:bg-slate-50",
};
